import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "utils/http";
import { BUSINESS } from "constants/api";

interface IBusinessesSearchParams {
  name: string;
  email: string;
  status: any;
}

export interface IBusinessesResponse extends ApiResponse {
  data: any;
}

export interface IFetchBusinessesArgs extends ReduxAction {
  page: number;
  queries: IBusinessesSearchParams;
}

export interface IFetchSingleBusinessResponse extends ApiResponse {
  data: any;
}

export interface IFetchSingleBusinessArgs extends ReduxAction {
  id: number;
}

export const fetchBusinesses = createAsyncThunk(
  BUSINESS.LIST,
  async (
    { page, queries, onFailure }: IFetchBusinessesArgs,
    { rejectWithValue }
  ) => {
    try {
      const searchParams = new URLSearchParams();

      if (Object.values(queries)?.length) {
        Object.entries(queries).forEach(([key, value]) => {
          if (value) {
            searchParams.append(`${key}`, value);
          }
        });
      }

      const { data }: IBusinessesResponse = await axios.get(`${BUSINESS.LIST}?page=${page}`, {
        params: searchParams,
      });

      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const fetchSingleBusiness = createAsyncThunk(
  BUSINESS.DETAIL,
  async ({ id, onFailure }: IFetchSingleBusinessArgs, { rejectWithValue }) => {
    try {
      const { data }: IFetchSingleBusinessResponse = await axios.get(
        BUSINESS.DETAIL.replace(":id", String(id))
      );

      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateVBusinessStatus = createAsyncThunk(
  BUSINESS.MANUAL_REVIEW,
  async (
    { payload, business_id, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        BUSINESS.MANUAL_REVIEW.replace(":id", String(business_id)),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateShareVBusinessStatus = createAsyncThunk(
  BUSINESS.SHAREHOLDER_MANUAL_REVIEW,
  async (
    { payload, shareholder_id, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        BUSINESS.SHAREHOLDER_MANUAL_REVIEW.replace(":id", String(shareholder_id)),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateRestrictTeam = createAsyncThunk(
  BUSINESS.RESTRICT_TEAM_MEMBER,
  async (
    { payload, business_id, id, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        BUSINESS.RESTRICT_TEAM_MEMBER.replace(":businessId", String(business_id)).replace(
          ":userId",
          String(id)
        ),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const createBusinessExchangeRate = createAsyncThunk(
  BUSINESS.CREATE_EXCHANGE_RATE,
  async (
    { payload, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        BUSINESS.CREATE_EXCHANGE_RATE,
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
